module.exports = __webpack_public_path__ + "static/img/LOGO21.9b18fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/LOGO21.png
// module id = CgEf
// module chunks = 0